// Подредбата на редовете в „Целия списък" — едно място за височините (от тях
// смята прозорецът useCatalogWindow) и за ширините на колоните (хедърът и
// редовете ползват СЪЩИТЕ класове, иначе колоните се разминават).
//
// Плътност: ЕДИН ред на продукт — вторичното (втори текст, групата,
// метатекстът) стои приглушено до името, не на втори ред. Височината е
// общата `ROW_DENSE` (ред с контроли: 34px с мишка, 44px с пръст), на телефон
// — винаги 44px. Прозорецът мери истинската височина в браузъра; числата тук
// са резервата преди първото мерене (и в jsdom).
import { ROW_DENSE, ROW_HEADER, ROW_HEADER_TEXT } from "../list/density";
import type { CatalogColumns } from "./catalogPickerModel";

// columns — решетката с колони; meta — заварения ред с метатекст (без колони);
// narrow — телефон
export type CatalogRowVariant = "columns" | "meta" | "narrow";

export const catalogRowVariantOf = (isNarrow: boolean, columns: CatalogColumns): CatalogRowVariant =>
  isNarrow ? "narrow" : !columns.structured ? "meta" : "columns";

export const CATALOG_ROW_HEIGHT: Record<CatalogRowVariant, number> = {
  columns: 34,
  meta: 34,
  narrow: 44,
};

// Височината е фиксирана: съдържанието е винаги един ред (truncate), а
// полетата са по-ниски от реда (24px / 36px с пръст / 38px на телефон) — затова min-h на
// ROW_DENSE е точната височина
export const CATALOG_ROW_HEIGHT_CLASS: Record<CatalogRowVariant, string> = {
  columns: ROW_DENSE,
  meta: ROW_DENSE,
  // 44px: полетата са 38px → по-малък вертикален отстъп
  narrow: `${ROW_DENSE} !min-h-11 !py-0.5`,
};

// Лепнатият хедър на колоните (ROW_HEADER — 30px, както навсякъде) — вади
// се от видимата височина; прозорецът го мери
export const CATALOG_HEADER_HEIGHT = 30;
export const CATALOG_HEADER_CLASS = `${ROW_HEADER} ${ROW_HEADER_TEXT}`;

// Хоризонталните отстъпи и колоните — общи за хедъра и редовете
export const CATALOG_ROW_GUTTER_CLASS = "gap-3 pl-4 pr-5";
export const CATALOG_NARROW_GUTTER_CLASS = "gap-2 px-3";
export const CATALOG_CHECK_CELL_CLASS = "flex w-[18px] shrink-0 items-center justify-center";
export const CATALOG_UNIT_CELL_CLASS = "w-[60px] shrink-0 truncate";
export const CATALOG_STOCK_CELL_CLASS = "w-[100px] shrink-0 truncate text-right";
// „Мин." — само в широк списък (контейнерна заявка към @container на списъка)
export const CATALOG_MINIMUM_CELL_CLASS = "hidden w-[80px] shrink-0 truncate text-right @min-[1000px]:block";
export const CATALOG_PRICE_CELL_CLASS = "w-[96px] shrink-0 truncate text-right";
// Полетата: количество + мярката до него; сумата на реда (доставка)
export const CATALOG_QTY_CELL_CLASS = "flex w-[136px] shrink-0 items-center justify-end gap-1.5";
export const CATALOG_SUM_CELL_CLASS = "w-[88px] shrink-0 truncate text-right";
// Телефон: наличността и цената вдясно на реда, полетата — на мястото им
export const CATALOG_NARROW_STOCK_CLASS = "max-w-[104px] shrink-0 truncate text-right";
export const CATALOG_NARROW_PRICE_CLASS = "w-[52px] shrink-0 truncate text-right";

// id на реда за aria-activedescendant на филтъра
export const catalogOptionId = (listId: string, itemId: number) => `${listId}-row-${itemId}`;
